import '@babel/polyfill'
import LazyLoad from 'vanilla-lazyload'

export default () => {
  window.lazyload = new LazyLoad({
    elements_selector: '.lazy',
    class_loading: '-lazyLoading',
    class_loaded: '-lazyLoaded',
    class_error: '-lazyError'
  })
}
